<div
  class="d-flex mb-4 flex-xl-row flex-lg-row flex-md-row flex-sm-column flex-column"
>
  <label
    for="upload-container"
    class="d-flex pl-0 col-xl-4 col-lg-4 col-md-4 col-sm-12"
    >{{ label }}</label
  >
  <div
    id="upload-container"
    class="upload-container col-xl-8 col-lg-8 col-md-8 col-sm-12 mb-2"
  >
    <div class="d-flex flex-column">
      <div>
        <div
          class="d-inline-flex upload-reel"
          [class.no-image]="!showThumbnail"
        >
          <div
            class="reel-banner-image"
            [style.background-image]="reelImage"
            *ngIf="showThumbnail; else contentReel"
          ></div>
          <ng-template #contentReel>
            <div class="reel-banner-image bg-white"></div>
          </ng-template>
          <div class="opacity-layer"></div>
          <i
            *ngIf="!showThumbnail"
            class="fas fa-cloud-upload-alt video-upload-icon"
          ></i>
          <span
            *ngIf="showCaption"
            id="upload-reel-txt"
            class="d-block text-center"
            >{{ captionKey | translate }}</span
          >
          <app-file-input
            inputId="uploadVideo"
            name="image"
            [accept]="acceptedFormats"
            [overlay]="true"
            (fileSelected)="uploadVideo($event)"
            (clickEvent)="selectVideo($event)"
          ></app-file-input>
          <i
            *ngIf="hasFile"
            class="fas fa-times-circle reel-remove-icon"
            [class.reel-remove-icon--on-light]="!showThumbnail"
            data-testid="upload-remove-icon"
            (click)="processRemoveVideo()"
          ></i>
        </div>
        <!-- Sits beside the tile as an inline-block sibling, so the tile's own
             layout and the video caller's spinner placement are untouched. The
             file is served as an attachment, so this downloads rather than
             previews — there is no PDF preview in the admin. -->
        <i
          *ngIf="showDownload && hasFile"
          class="fas fa-cloud-download-alt file-download-icon"
          role="button"
          tabindex="0"
          data-testid="upload-download-icon"
          [attr.aria-label]="'admin.global.download' | translate"
          (click)="downloadFile()"
          (keydown.enter)="downloadFile()"
          (keydown.space)="downloadFile()"
        ></i>
        <app-loading-panel
          [showLoading]="isUploading"
          [variant]="'overlay'"
          [hideText]="false"
        >
        </app-loading-panel>
      </div>
      <div>
        <app-explanation class="not-subscribed-text">{{
          infoMessage
        }}</app-explanation>
      </div>
    </div>
  </div>
</div>
